import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AdminUserManagement.css";
import { FaCheckCircle, FaTimesCircle, FaTrash, FaEllipsisV, FaEdit } from "react-icons/fa";


const sports = ["Select", "Cricket", "Football", "Kabaddi", "Hockey", "Basketball", "Volleyball"];
const types = ["Select", "Individual", "Team"];
const genders = ["Select", "Men", "Women"];

export default function AdminUserManagement() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sportFilter, setSportFilter] = useState("Select");
  const [typeFilter, setTypeFilter] = useState("Select");
  const [genderFilter, setGenderFilter] = useState("Select");

  const API_BASE = "https://node.aattumtpl.com/api/admin";

  const customSelectStyle = {
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    backgroundImage: `url("data:image/svg+xml;utf8,<svg fill='%23222' height='14' viewBox='0 0 24 24' width='14' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 8px center",
    backgroundSize: "14px",
    paddingRight: "24px",
  };

  // Fetch both individual + team models
  const fetchRecords = async () => {
    setLoading(true);
    try {
      const teamRes = await axios.get(`${API_BASE}/${sportFilter}`);
      // Individual model name: prefix "Individual" + sport
      const individualRes = await axios.get(`${API_BASE}/Individual${sportFilter}`);
      // Merge both arrays
      const allRecords = [...teamRes.data, ...individualRes.data];
      setRecords(allRecords);
    } catch (err) {
      console.error("Error fetching records:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRecords();
  }, [sportFilter]);

  // Update Status
  const updateStatus = async (id, status) => {
    try {
      await axios.put(`${API_BASE}/${id}/status`, { status });
      fetchRecords();
    } catch (err) {
      console.error(err);
    }
  };

  // Delete Record
  const deleteRecord = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;
    try {
      await axios.delete(`${API_BASE}/${id}`);
      fetchRecords();
    } catch (err) {
      console.error(err);
    }
  };

  const editRecord = (rec) => {
    alert(`Edit record for ${rec.name || rec.teamName} coming soon!`);
  };

  // Filter by type, gender, search
  const filtered = records.filter((rec) => {
    const name = rec.name || rec.teamName || "";
    const gender = rec.gender || "";
    const type = rec.type || "";
    const searchMatch = name.toLowerCase().includes(search.toLowerCase());
    const typeMatch = typeFilter === "All" || type === typeFilter;
    const genderMatch = genderFilter === "All" || gender === genderFilter;
    return searchMatch && typeMatch && genderMatch;
  });

  return (
    <>

      <div className="admin-container">
        <div className="admin-header">
          <h2>User Management</h2>
          <div className="admin-controls">
            <select
              value={sportFilter}
              onChange={(e) => setSportFilter(e.target.value)}
              style={customSelectStyle}
            >
              {sports.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>

            <select
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              style={customSelectStyle}
            >
              {types.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>

            <select
              value={genderFilter}
              onChange={(e) => setGenderFilter(e.target.value)}
              style={customSelectStyle}
            >
              {genders.map((g) => (
                <option key={g} value={g}>{g}</option>
              ))}
            </select>

            <input
              type="text"
              placeholder="Search by name or team..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

        </div>

        {loading ? (
          <p className="loading">Loading records...</p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>{typeFilter === "Team" ? "Team Name" : "Name"}</th>
                <th>Sport</th>
                <th>Type</th>
                <th>{typeFilter === "Team" ? "Players" : "Age"}</th>
                <th>Gender</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan={7} style={{ textAlign: "center" }}>No records found</td>
                </tr>
              ) : (
                filtered.map((rec) => (
                  <tr key={rec._id}>
                    <td>{rec.teamName || rec.name}</td>
                    <td>{rec.sport}</td>
                    <td>{rec.type}</td>
                    <td>{rec.players?.length || rec.age || "N/A"}</td>
                    <td>{rec.gender || "N/A"}</td>
                    <td>
                      <span className={`status-badge ${rec.status}`}>
                        {rec.status}
                      </span>
                    </td>
                    <td className="action-cell">
                      <div className="dropdown top-dropdown">
                        <FaEllipsisV className="dropdown-toggle" />
                        <div className="dropdown-menu">
                          <button onClick={() => updateStatus(rec._id, "approved")}>
                            <FaCheckCircle /> Approve
                          </button>
                          <button onClick={() => updateStatus(rec._id, "rejected")}>
                            <FaTimesCircle /> Reject
                          </button>
                          <button onClick={() => editRecord(rec)}>
                            <FaEdit /> Edit
                          </button>
                          <button onClick={() => deleteRecord(rec._id)}>
                            <FaTrash /> Delete
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
